module.exports = __webpack_public_path__ + "static/media/icon_chatIcon.bcf79b53.svg";